import React, { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  icon?: string | React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error, label, id, icon, ...props }, ref) => {
    // Generate a stable ID if none is provided, useful for linking label to input
    const generatedId = React.useId();
    const inputId = id || generatedId;
    
    return (
      <div className="w-full flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className="sm:text-sm text-xs text-slate-700">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              {typeof icon === 'string' ? <i className={icon} /> : icon}
            </span>
          )}
          <input
            id={inputId}
            ref={ref}
            className={`flex h-10 w-full rounded-md border bg-white ${icon ? 'pl-9 pr-3' : 'px-3'} py-2 sm:text-sm text-xs placeholder:text-slate-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-50 transition-colors ${
              error ? 'border-red-500 focus:ring-red-500' : 'border-slate-200 hover:border-slate-300'
            } ${className}`}
            {...props}
          />
        </div>
        {error && <span className="text-xs text-red-500">{error}</span>}
      </div>
    );
  }
);
Input.displayName = 'Input';
